import React from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { IoHomeSharp } from "react-icons/io5";
import {
  FiPackage,
  FiLayers,
  FiActivity,
  FiSettings,
  FiLogOut,
  FiUsers,
  FiImage,
  FiFileText,
  FiGift,
} from "react-icons/fi";
import { SiYourtraveldottv } from "react-icons/si";
import { MdLocalHotel, MdTravelExplore, MdLocalTaxi } from "react-icons/md";
import { useDispatch } from "react-redux";

import Logo from "../../assets/png/logo.png";
import { LOGOUT, UPDATE_OFFSET } from "../../actions/actionType";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;
  const dispatch = useDispatch();

  const links = [
    {
      name: "Dashboard",
      path: "/",
      icon: <IoHomeSharp />,
    },
    {
      name: "Packages",
      path: "/packages",
      icon: <FiPackage />,
    },
    {
      name: "Sub Packages",
      path: "/sub-packages",
      icon: <FiLayers />,
    },
    {
      name: "Top Attractions",
      path: "/top-attractions",
      icon: <SiYourtraveldottv />,
    },
    {
      name: "Activities",
      path: "/activities",
      icon: <FiActivity />,
    },
    {
      name: "Testimonials",
      path: "/testimonials",
      icon: <FiUsers />,
    },
    {
      name: "Bookings",
      path: "/bookings",
      icon: <MdTravelExplore />,
    },
    {
      name: "Settings",
      path: "/settings",
      icon: <FiSettings />,
    },
    {
      name: "FAQ",
      path: "/faqs",
      icon: <FiPackage />,
    },
    {
      name: "Gallery",
      path: "/gallery",
      icon: <FiImage />,
    },
    {
      name: "Blogs",
      path: "/blogs",
      icon: <FiFileText />,
    },
    {
      name: "Offers",
      path: "/offers",
      icon: <FiGift />,
    },
    {
      name: "Taxi Rental",
      path: "/taxis",
      icon: <MdLocalTaxi />,
    },
    {
      name: "Taxi Bookings",
      path: "/taxi-bookings",
      icon: <MdTravelExplore />,
    },
  ];

  const handleLogout = () => {
    dispatch({ type: LOGOUT });
  };

  return (
    <div className="min-h-screen w-60  fixed inset-y-0 left-2 py-2 bg-gray-100">
      <div className="bg-white  w-full h-full rounded-2xl shadow-primaryShadow">
        <div className="py-4 flex items-center justify-center">
          <img src={Logo} alt="company logo" width={200} />
        </div>
        <ul className="py-8 px-4">
          {links.map((link, index) => {
            return (
              <li
                className={`flex gap-x-4 items-center px-4 py-1  mb-3 rounded-md cursor-pointer group 
                ${
                  pathname.includes(link.path.toString()) &&
                  pathname.split("/")[1] === link.path.split("/")[1]
                    ? "bg-green-100 link-active"
                    : " bg-transparent"
                }`}
                key={index}
                onClick={() => {
                  navigate(`${link.path}`);
                  dispatch({ type: UPDATE_OFFSET, payload: 1 });
                }}
              >
                <div
                  className={` text-xl group-hover:animate-bounce  ${
                    pathname.includes(link.path.toString()) &&
                    pathname.split("/")[1] === link.path.split("/")[1]
                      ? "text-primary group-hover:text-primary"
                      : " text-tertiary group-hover:text-primary"
                  }`}
                >
                  {link.icon}
                </div>
                <p
                  className={`font-medium font-Nunito text-lg   ${
                    pathname.includes(link.path.toString()) &&
                    pathname.split("/")[1] === link.path.split("/")[1]
                      ? "text-primary group-hover:text-primary"
                      : " text-tertiary group-hover:text-primary"
                  }`}
                >
                  {link.name}
                </p>
              </li>
            );
          })}
        </ul>
        <button
          className=" mx-8 py-2 rounded-md flex gap-x-4 items-center absolute bottom-5"
          onClick={() => handleLogout()}
        >
          <FiLogOut className="text-xl text-red-700" />
          <p className=" font-Nunito font-medium text-lg text-red-700">
            Logout
          </p>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
